import { render, staticRenderFns } from "./Level.vue?vue&type=template&id=5466ea10&scoped=true&"
import script from "./Level.vue?vue&type=script&lang=js&"
export * from "./Level.vue?vue&type=script&lang=js&"
import style0 from "./Level.vue?vue&type=style&index=0&id=5466ea10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5466ea10",
  null
  
)

export default component.exports